import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { BookingSystem } from "@/components/BookingSystem";
import { Footer } from "@/components/Footer";
import { usePageSeo } from "@/hooks/usePageSeo";

const BookingPage = () => {
  const { language, url, onLanguageChange } = usePageSeo();

  const meta = {
    es: {
      title: "Agendar reunión inicial gratuita | Luis ROC",
      description: "Agenda una reunión inicial gratuita de 30 minutos con Luis ROC para revisar el contexto de tu negocio y determinar posibles siguientes pasos.",
    },
    en: {
      title: "Book Free Initial Consultation | Luis ROC",
      description: "Book a free 30-minute initial consultation with Luis ROC to review your business context and determine possible next steps.",
    }

  };

  const currentMeta = meta[language];

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>{currentMeta.title}</title>
        <meta name="description" content={currentMeta.description} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={currentMeta.title} />
        <meta property="og:description" content={currentMeta.description} />
        <meta property="og:url" content={url} />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={onLanguageChange} />
        
        <main className="pt-24 pb-12">
          <BookingSystem language={language} />
        </main>
        
        <Footer language={language} />
      </div>
    </>
  );
};

export default BookingPage;